import styled from "styled-components";
import Box from "../Box";
import Button from "../Button";
import { Colors, MERCHANT_STATUS } from "../../config/Constants";
import Selectfield from "./Selectfield";
import Textfield from "./Textfield";
import DropdownCheckbox from "../DropdownCheckbox";

interface Props {
  isEditFlow: boolean;
  onSubmit: () => void;
  onRoleSelect: (id: string) => void;
  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => void;
  onCancel: () => void;
  value: {
    name: string;
    password: string;
    role: any;
    email: string;
    status: string;
    outlet: string;
  };
  error: {
    name: string;
    password: string;
    role: string;
    email: string;
    status: string;
    outlet: string;
  };
  roles: (
    | { label: string; value: string }
    | { label: string; value: number }
  )[];
  outlets: (
    | { label: string; value: string; type: string }
    | { label: string; value: number; type: string }
  )[];
}

const ManageMerchantFormContainer = ({
  onSubmit,
  onCancel,
  onChange,
  value,
  error,
  roles,
  outlets,
  isEditFlow,
  onRoleSelect,
}: Props) => {
  return (
    <Container>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="name"
                label="Name"
                placeholder="Enter the name"
                onChange={onChange}
                value={value.name}
                required
                helperText={error["name"]}
                disabled={isEditFlow}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="outlet"
                label="Outlet"
                onChange={onChange}
                data={outlets}
                value={value.outlet}
                required
                helperText={error["outlet"]}
                disabled={
                  isEditFlow ||
                  !(value.role.includes(3) || value.role.includes(5) || value.role.includes(8))
                }
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <DropdownCheckbox
                name="role"
                label="Role"
                onChange={onChange}
                data={roles}
                value={value.role}
                required
                helperText={error["role"]}
                disabled={isEditFlow}
                placeholder="Select Role"
                onRoleSelect={onRoleSelect}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="status"
                label="Status"
                onChange={onChange}
                data={MERCHANT_STATUS}
                required
                value={value.status}
                helperText={error["status"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                disabled={isEditFlow}
                name="email"
                label="Email"
                placeholder="Enter email"
                onChange={onChange}
                value={value.email}
                required
                helperText={error["email"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                disabled={isEditFlow}
                name="password"
                label="Password"
                placeholder="Enter password"
                onChange={onChange}
                value={value.password}
                required
                helperText={error["password"]}
              />
            </FieldWrapper>
          </FormRow>

          <ActionRow>
            <FieldWrapper />
            <ButtonWrapper>
              <Button
                variant="outlined"
                label="Cancel"
                onClick={onCancel}
                width="9.7rem"
              />
              <Button
                color={Colors.red}
                variant="filled"
                label="Save"
                onClick={onSubmit}
                width="9.7rem"
              />
            </ButtonWrapper>
          </ActionRow>
        </FormWrapper>
      </Box>
    </Container>
  );
};

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const Container = styled.div`
  margin-top: 1.5rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

export default ManageMerchantFormContainer;
